import React, { useContext, memo } from 'react';
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import { Context } from '../../context';
import './style.css';
import { Icon, InlineIcon } from '@iconify/react/dist/iconify.js';

const Spinner = () => {
    const { loading } = useContext(Context)

    return (
        <div id={loading ? "spinner" : ''} className='normalpose' >
            <InlineIcon icon={"cuida:medicine-outline"} className='loadingIcon loadingIconNormal'/>
            <InlineIcon icon={"cuida:medicine-outline"} className='loadingIcon loadingIconReverse'/>
        </div>
    );
}

export default memo(Spinner);